import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Link } from 'react-router-dom'

const CreateAccountPopUp = () => {
    return (
        <div>
            <Dialog>
                <DialogContent className='min-w-max'>
                    <DialogHeader>
                        <DialogTitle>Save your account!</DialogTitle>
                        <p className='text-sm text-gray-500'>This demo account would be deleted in 5 hours</p>
                    </DialogHeader>

                    <DialogFooter>
                        <Link to={`?upgrade=true`}>Create Account</Link>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default CreateAccountPopUp
